import { render, staticRenderFns } from "./MitmachenJoinTab.vue?vue&type=template&id=6bd8e79f&scoped=true&"
import script from "./MitmachenJoinTab.vue?vue&type=script&lang=js&"
export * from "./MitmachenJoinTab.vue?vue&type=script&lang=js&"
import style0 from "./MitmachenJoinTab.vue?vue&type=style&index=0&id=6bd8e79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8e79f",
  null
  
)

export default component.exports